import { API_URL } from "src/consts/urls";

export const API_COMMENT_V2_URL = `${API_URL}/v2/comment`;
export const API_COMMENT_SEARCH_V2_URL = `${API_URL}/v2/comment/search`;
export const API_COMMENT_REPLY = `${API_COMMENT_V2_URL}/replies`;
